import { Petitum } from '../../../models/petitum';

export class PetitumAdapter {

  petitum: Petitum = new Petitum();

  constructor(petitum: Petitum) {
    this.petitum.id = petitum.id;
    this.petitum.tipoPetitum = petitum.tipoPetitum ? JSON.parse(JSON.stringify(petitum.tipoPetitum)) : null;
    this.petitum.importoPetitum = petitum.importoPetitum;
    this.petitum.interessiPetitum = petitum.interessiPetitum;
    this.petitum.dataInizioCalcoloInteressi = petitum.dataInizioCalcoloInteressi;
    this.petitum.dataInizioCalcoloInteressiSpeseLegali = petitum.dataInizioCalcoloInteressiSpeseLegali;
    this.petitum.compensi = petitum.compensi;
    this.petitum.spese = petitum.spese;
    this.petitum.altro = petitum.altro;
    this.petitum.gradoRischio = petitum.gradoRischio ? JSON.parse(JSON.stringify(petitum.gradoRischio)) : null;
    this.petitum.percentualeSoccombenza = petitum.percentualeSoccombenza;
    this.petitum.accantonamentoPetitum = petitum.accantonamentoPetitum;
    this.petitum.accantonamentoInteressi = petitum.accantonamentoInteressi;
//    this.petitum.accantonamentoCostiGestione = petitum.accantonamentoCostiGestione;
    this.petitum.accantonamentoCompensiSpeseTotale = petitum.accantonamentoCompensiSpeseTotale;
    this.petitum.petitumRevisioni = petitum.petitumRevisioni;
    this.petitum.fondoRischi = petitum.fondoRischi ? petitum.fondoRischi : false ;
    this.petitum.costiGestione = petitum.costiGestione;
    this.petitum.speseRegistrazione = petitum.speseRegistrazione;
    this.petitum.contributoUnificato = petitum.contributoUnificato;
    this.petitum.altroImporto = petitum.altroImporto;
    this.petitum.note = petitum.note;
  }
}
